import { cloneDeep } from 'lodash';
import jdenticon from 'jdenticon';
import collect from 'collect.js';
import moment from 'moment';

export const getProfileItemValue = item => (Array.isArray(item) ? item[0] : item);
export const profileCampaignDateFormat = text => moment(text).format('DD/MM/YYYY');
export const getDataItem = (profile, profileSection, property, defaultValue = null) => {
  const currentProfile = cloneDeep(profile);
  let dataItem = defaultValue;
  if (
    currentProfile &&
    currentProfile[profileSection] &&
    property in currentProfile[profileSection]
  ) {
    const sortedIdentifiers = collect(currentProfile[profileSection][property])
      .sortBy('score')
      .toArray();

    if (sortedIdentifiers.length) {
      dataItem = sortedIdentifiers[0].value;
    }
  }

  return getProfileItemValue(dataItem);
};

export const getPrimaryIdentifier = profile => {
  const identifiers = [
    ['identifiers', 'facebook_profile'],
    ['identifiers', 'twitter_handle'],
    ['identifiers', 'email_address'],
    ['identifiers', 'wechat_handle'],
    ['identifiers', 'instagram_handle'],
    ['identifiers', 'telegram'],
    ['identifiers', 'mobile_number'],
    ['identifiers', 'cellfind_handle'],
    ['identifiers', 'whatsapp_handle'],
  ];

  const primaries = identifiers.reduce((acc, ident) => {
    const value = getDataItem(profile, ident[0], ident[1], null);
    if (value) {
      return [...acc, value];
    }
    return acc;
  }, []);

  if (!primaries.length) {
    return 'Unknown';
  }
  return primaries[0];
};

export const getProfileIdenticon = profile => {
  const identifier = getPrimaryIdentifier(profile);
  const identiconToBase64 = btoa(jdenticon.toSvg(identifier, 128));
  return `data:image/svg+xml;base64,${identiconToBase64}`;
};

export const findWordInStr = (word, str) => {
  if (str === undefined) return 'other';
  const regex = new RegExp(`${word}`);
  const lowerCaseStr = str.toLowerCase();

  if (regex.exec(lowerCaseStr) !== null) {
    return word;
  }
  return 'other';
};
export const getAgeFromYear = ageIndex => {
  const { value } = ageIndex;
  const birthYear = new Date(value).getFullYear();
  const currentYear = new Date(Date.now()).getFullYear();
  return Number(currentYear - birthYear);
};
export const getColourCode = (score, discoveredBy) => {
  let key = 'other';

  const hue = (score * 120).toString(10);

  const colourMap = {
    surveys: 'hsla(300, 100%, 25%, 0.4)',
    other: `hsl(${hue}, 50%, 70%)`,
  };

  const activeDataFields = Object.keys(colourMap);
  for (let i = 0; i < activeDataFields.length; i += 1) {
    if (activeDataFields[i] === findWordInStr(activeDataFields[i], discoveredBy)) {
      key = activeDataFields[i];
      break;
    }
  }
  return colourMap[key];
};

export const orderAgeProfiles = ageProfiles => {
  const ageRanges = ['Under 18', '18-24', '25-34', '35-49', '50-64', '65+'];
  const orderedRanges = [];
  ageRanges.forEach(ageRangeKey => {
    const ageProfile = ageProfiles.find(c => c.ageBracket === ageRangeKey);
    if (ageProfile) {
      orderedRanges.push(ageProfile);
    }
  });
  return orderedRanges;
};
// export const defaultProfileImg = '/static/assets/icons/user/default_profile_normal.png';



// WEBPACK FOOTER //
// ./src/components/profile/profileUtils.js